import { createContext } from 'react';
import { AddNewIntegrationReducerResult } from '../reducers/addNewIntegration';

const defaultState = {
    isIntegrationScrollerOpen: false,
};
export const AddNewIntegrationContext = createContext<AddNewIntegrationReducerResult>(defaultState);
